import { paths } from 'src/routes/paths';

export const BASE_URL = 'https://vitrine.beneficioscenternorte.roxcode.io/';
export const API_URL = 'https://cn.backend.roxcode.io';
export const { SENTRY_DSN } = import.meta.env;
export const { ASSETS_API_URL } = import.meta.env;

export const PATH_AFTER_LOGIN = paths.home.root;
